import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useEffect } from "react";

export function HomeRedirector() {
  const navigate = useFixaNavigate();
  useEffect(() => {
    navigate("/home", { replace: true });
  }, [navigate]);

  return null;
}
